module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parallax-container valign-wrapper"
  }, [_c('section', {
    staticClass: "section no-pad-bot"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row center"
  }, [_c('h2', {
    staticClass: "header col s12 light-image"
  }, [_vm._v(" Prisma, TypeORM ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "parallax"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/img/rodape.jpg"),
      "alt": "Node.js, MongoDB..."
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1040b44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-h-foot-banner.vue
// module id = 423
// module chunks = 1